import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { SettingsDialog } from '../../../components'

const mapStateToProps = (state, ownProps) => {
  const { open, settings } = state.settingsDialog
  return ({
    open,
    settings,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleEnter: () => {
      ownProps.onEnter()
    },
    handleOK: (settings) => () => {
      ownProps.onOK(settings)
      dispatch(actions.settingsDialog.close())
    },
    handleClose: () => {
      dispatch(actions.settingsDialog.close())
    },
    handleChangeCheckbox: (name) => (event) => {
      dispatch(actions.settingsDialog.changedCheckbox(name, event.target.checked))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SettingsDialog)



// WEBPACK FOOTER //
// ./src/containers/Common/RenjuBoardCard/SettingsDialog.js